export default __webpack_public_path__ + "static/media/Python.d43cba49.webp";